import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  keywords
}) => {
  const siteTitle = 'Omnia Paratus Talent Solutions';
  const pageTitle = title 
    ? title + ' | ' + siteTitle 
    : siteTitle + ' | Premier Recruiting & Staffing Agency';
  const metaDescription = description || 'Omnia Paratus Talent Solutions is a premier recruiting and staffing agency specializing in direct hire recruiting for accounting, healthcare, logistics, and HR & people compliance industries. Serving Massachusetts and nationwide.';
  const metaKeywords = keywords || 'recruiting agency, staffing firm, direct hire recruiting, healthcare recruiters, accounting recruiters, logistics recruiters, HR recruiters, people compliance recruiters, Massachusetts recruiting agency, nationwide recruiting firm, Boston staffing agency, talent acquisition, executive search';

  useEffect(() => {
    // Set document title
    document.title = pageTitle;

    // Update meta description
    let metaDescTag = document.querySelector('meta[name="description"]');
    if (metaDescTag) {
      metaDescTag.setAttribute('content', metaDescription);
    }

    // Update meta keywords
    let metaKeywordsTag = document.querySelector('meta[name="keywords"]');
    if (metaKeywordsTag) {
      metaKeywordsTag.setAttribute('content', metaKeywords);
    }

    // Update OG title
    let ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute('content', pageTitle);
    }

    // Update OG description
    let ogDescTag = document.querySelector('meta[property="og:description"]');
    if (ogDescTag) {
      ogDescTag.setAttribute('content', metaDescription);
    }
  }, [pageTitle, metaDescription, metaKeywords]);

  return null;
};

export default SEO;
